import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faMapMarkerAlt, faPhone, faEnvelope, faClock } from '@fortawesome/free-solid-svg-icons';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="main-footer">
      <div className="container">
        <div className="footer-section">
          <h4>Star Deli & Restaurant</h4>
          <p>Famous for our delicious sandwiches, soups, and deli items since 1973.</p>
          <div className="social-links">
            <a href="https://www.facebook.com/p/Star-Deli-Southfield-100057420071077/" aria-label="Facebook">
              <FontAwesomeIcon icon={faFacebook} />
            </a>
            <a href="https://www.instagram.com/stardelisouthfield/" aria-label="Instagram">
              <FontAwesomeIcon icon={faInstagram} />
            </a>
          </div>
        </div>

        <div className="footer-section">
          <h4>Quick Links</h4>
          <Link to="/">Home</Link>
          <Link to="/menu">Menu</Link>
          <Link to="/catering">Catering</Link>
          <Link to="/about">About Us</Link>
          <Link to="/contact">Contact</Link>
        </div>

        <div className="footer-section">
          <h4>Contact Info</h4>
          <p>
            <FontAwesomeIcon icon={faMapMarkerAlt} />
            <span>24555 W 12 Mile Rd, Southfield, MI 48034</span>
          </p>
          <p>
            <FontAwesomeIcon icon={faPhone} />
            <span><a href="tel:248-352-7377">(248) 352-7377</a></span>
          </p>
          <p>
            <FontAwesomeIcon icon={faEnvelope} />
            <span><a href="mailto:management@stardeli.net">management@stardeli.net</a></span>
          </p>
        </div>

        <div className="footer-section">
          <h4>Hours of Operation</h4>
          <p>
            <FontAwesomeIcon icon={faClock} />
            <span>Monday - Friday: 8:00 AM - 7:00 PM</span>
          </p>
          <p>
            <FontAwesomeIcon icon={faClock} />
            <span>Saturday: 8:00 AM - 7:00 PM</span>
          </p>
          <p>
            <FontAwesomeIcon icon={faClock} />
            <span>Sunday: 8:00 AM - 7:00 PM</span>
          </p>
        </div>
      </div>
      
      <div className="copyright">
        <div className="container">
          <p>&copy; {new Date().getFullYear()} Star Corned Beef Center. All rights reserved.</p>
        </div>
      </div>

      {/* Build version — injected at build time via REACT_APP_COMMIT_SHA.
          Updates every commit because the build script reads
          `git rev-parse --short HEAD` before webpack runs. */}
      <div className="build-version" aria-hidden="true">
        v{process.env.REACT_APP_COMMIT_SHA || 'dev'}
      </div>
    </footer>
  );
};

export default Footer;